import { useMutation } from '@tanstack/react-query';

export default function useUpdateOrganizationStaffAttachAvatar() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: { id: number; avatar: File }) => {
      const formData = new FormData();
      formData.append('avatar', params.avatar);

      const response = await fetch(`/agent/api/organization_users/${params.id}/attach_avatar`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Failed to attach avatar');
      }
      return await response.json();
    },
  });
}
